module.exports = __webpack_public_path__ + "img/bank-btn-effects.36f3fa0c.svg";